import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { Box, Button, Flex, Title, LoadingOverlay } from "@mantine/core";

import { BasicForm } from "@components/shared";
import { PasswordForm } from "@components/Auth";
import { PhoneCheck } from "./UserAuth";

export default function UserSignup({
  email,
  firstName,
  lastName,
  locationId,
  number,
  onSuccess,
  userLocationId,
  zip,
}) {
  const [loading, setLoading] = useState(false);
  const [demographics, setDemographics] = useState(null);
  const [step, setStep] = useState("demographics");
  const [tempPhone, setTempPhone] = useState("");

  if (!number && !tempPhone) {
    return (
      <PhoneCheck
        locationId={locationId}
        setUserScenario={(scenario) => {
          setTempPhone(scenario.number);
        }}
      />
    );
  }

  const fieldValues = demographics
    ? {
        first_name: demographics.first_name,
        last_name: demographics.last_name,
        email: demographics.email,
        zip: demographics.zip,
      }
    : {
        first_name: firstName,
        last_name: lastName,
        email: email,
        zip: zip,
      };

  function onSubmit(formData) {
    setLoading(true);

    const req = {
      ...formData,
      ...demographics,
      location_id: locationId,
      mobile_phone: tempPhone ? tempPhone : number,
    };

    if (userLocationId) req.user_location_id = userLocationId;

    axios
      .post(`/members/signup/`, { ...req })
      .then(({ data }) => {
        onSuccess(data.response[0]);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "first_name",
      label: "First Name",
      initialValue: fieldValues.first_name,
      required: true,
      schema: () => Yup.string().required("Required"),
    },
    {
      name: "last_name",
      label: "Last Name",
      initialValue: fieldValues.last_name,
      required: true,
      schema: () => Yup.string().required("Required"),
    },
    {
      name: "email",
      label: "Email",
      initialValue: fieldValues.email,
      required: true,
      schema: () =>
        Yup.string().email("Enter a valid email address").required("Required"),
    },
    {
      name: "zip",
      label: "Zip",
      initialValue: fieldValues.zip,
      required: true,
      schema: () =>
        Yup.string()
          .matches(
            /^[0-9]{5}$|^[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/,
            "Not a valid zip"
          )
          .required("Required"),
    },
  ];

  return (
    <Box>
      <LoadingOverlay visible={loading} />
      <Title order={2} mb="lg" align="center">
        {step === "pw" ? "Create password" : "Fill out this form"}
      </Title>
      {step === "pw" ? (
        <React.Fragment>
          <PasswordForm fullWidth returnEarly={(e) => onSubmit(e)} />
          <Flex justify="center">
            <Button
              variant="subtle"
              mt="sm"
              onClick={() => setStep("demographics")}
            >
              back
            </Button>
          </Flex>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <BasicForm
            onSubmit={(e) => {
              setDemographics(e);
              setStep("pw");
            }}
            fields={fields}
            buttonProps={{
              fullWidth: true,
            }}
          />
        </React.Fragment>
      )}
    </Box>
  );
}

UserSignup.defaultProps = {
  email: "",
  firstName: "",
  lastName: "",
  zip: "",
};
